export const NavbarMixin = {
  methods: {
    goBack() {
      if (window.history.state && window.history.state.back) {
        (this as any).$router.back();
      } else {
        const previousUrl = localStorage.getItem("previous_url");

        if (previousUrl) {
          try {
            const obj = JSON.parse(previousUrl);
            (this as any).$router.push(obj);
          } catch (error) {
            console.log(error);
            (this as any).$router.push("/history-list");
          }
        } else {
          (this as any).$router.push("/history-list");
        }
      }
    },
  },
};
